export const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT

export default {
  API_ENDPOINT,
}
